import { tw } from '@/utils/tw';
import BaseArticleFooterTheme from 'base/components/ArticleFooter/theme';

const DisclaimerLink = tw.theme({
  extend: BaseArticleFooterTheme.DisclaimerLink,
});

const Tag = tw.theme({
  extend: BaseArticleFooterTheme.Tag,
});

const ArticleFooter = tw.theme({
  extend: BaseArticleFooterTheme,
  slots: {
    base: `mt-6 w-full gap-5.5`,
  },
  defaultVariants: {
    center: true,
  },
});

export default Object.assign(ArticleFooter, { Tag, DisclaimerLink });
